import _ from 'lodash'

/**
 * Helper for printing features
 *
 * @type {ngService}
 */
export class TmrPrint {
  static ngType = 'service'

  constructor(
    $injector,
    $state,
    $stateParams,
    TmrLocalStorage,
    TmrOperationHelper,
    UserStorage
  ) {
    'ngInject'
    Object.assign(this, {
      $injector,
      $state,
      $stateParams,
      TmrLocalStorage,
      TmrOperationHelper,
      UserStorage,
    })
  }

  get printCartEnabled() {
    return this.TmrOperationHelper.getConfig('printCart')
  }

  get resourcesToPrint() {
    if (this.printCartEnabled) {
      this.resourceFactories = this.resourceFactories ?? {}
      this.resourcesToPrintArr =
        this.resourcesToPrintArr ??
        this.TmrLocalStorage.get('resourcesToPrint', []).map(({ id, type }) => {
          this.resourceFactories[type] =
            this.resourceFactories[type] ?? this.$injector.get(type)
          return this.resourceFactories[type].create({ id })
        })
      return this.resourcesToPrintArr
    }
    return this.$stateParams.resourcesToPrint
  }

  isResourceToPrint(resource) {
    return (
      this.resourcesToPrint.find(res => this.isSameResource(resource, res)) !==
      undefined
    )
  }

  updateResourcesToPrint(resourcesToPrint) {
    if (this.printCartEnabled) {
      delete this.resourcesToPrintArr
      this.TmrLocalStorage.set(
        'resourcesToPrint',
        resourcesToPrint.map(({ id, $getType }) => ({ id, type: $getType() }))
      )
      return Promise.resolve()
    }
    return this.$state.go('.', { resourcesToPrint })
  }

  addResourcesToPrint(resources) {
    if (!Array.isArray(resources)) resources = [resources]
    return this.updateResourcesToPrint(this.resourcesToPrint.concat(resources))
  }

  removeResourcesToPrint(resources) {
    if (!Array.isArray(resources)) resources = [resources]
    let remaining = _.differenceWith(this.resourcesToPrint, resources, (a, b) =>
      this.isSameResource(a, b)
    )
    return this.updateResourcesToPrint(remaining)
  }

  clearResourcesToPrint() {
    return this.updateResourcesToPrint([])
  }

  isSameResource({ $getType, id }, { $getType: $getTypeA, id: idA }) {
    return $getType() == $getTypeA() && id == idA
  }

  /** Retrieves and sorts Print Operation routes that logged user can access */
  getPrintOperations() {
    return this.$state.router.stateRegistry
      .get()
      .filter(state => {
        let parent = state.$$state().parent
        return (
          parent &&
          parent.name == 'app.operations.print' &&
          this.UserStorage.access(state)
        )
      })
      .sort(
        ({ weight: weightA = 0 }, { weight: weightB = 0 }) => weightA - weightB
      )
  }
}
